import { render, staticRenderFns } from "./prodottiWidgetAssociatiDistributori.vue?vue&type=template&id=e8fd0602&"
import script from "./prodottiWidgetAssociatiDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottiWidgetAssociatiDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports